import type { en } from './en.js';

/** Bulgarian: a future change (§18). Any key left out falls back to English. */
export const bg: Partial<Record<keyof typeof en, string>> = {};
